import { gsap, Power3 } from "gsap";

export default class HeaderNotification {
    constructor() {

        this.notification = document.querySelector(".js-header-notification");
        this.button = document.querySelector(".js-header-notification-btn");

        if (this.notification) {
            
            this.button.addEventListener("click", (e) => {
                this.close();
            });
            
        }

    }

    close() {
        document.cookie = "notification_closed=true";

        gsap.to(this.notification, {
            duration: .25,
            delay: .25,
            height: 0,
            display: 'none',
            ease: Power3.in,
            onComplete: () => {
                this.notification.style.display = 'none';
            }
        });

    }
}